// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"6816eb34","101":"425a63d5","133":"93199898","956":"1aa6be78"}[chunkId] + ".chunk.js";
};